<template>
  <SfiNavBar
    :app-title="title"
    logo="/logo.svg"
    :page-title="route.meta.title"
    :session="session"
    :apps="session.applications"
    @sign-out="signOut"
  >
    <ClaimSearch class="flex-grow-3" bg-color="surface-strong" />
  </SfiNavBar>
  <SideDrawer />
  <v-main class="main-app d-flex h-screen">
    <div class="w-100 overflow-y-auto">
      <router-view v-slot="{ Component }">
        <Transition :mode="'out-in'" :appear="true">
          <Suspense>
            <div class="pa-8 min-h-100">
              <component :is="Component" />
              <ScrollToTop />
            </div>
            <template #fallback>
              <v-progress-circular />
            </template>
          </Suspense>
        </Transition>
      </router-view>
    </div>
  </v-main>
</template>

<script setup lang="ts">
import ClaimSearch from '@/components/General/ClaimSearch.vue'
import ScrollToTop from '@/components/General/ScrollToTop.vue'
import SideDrawer from '@/components/SideDrawer.vue'
import { init } from '@/lib/flags'
import { useAuth } from '@simplifi/auth'
import { useRoute } from 'vue-router'
const title = import.meta.env.VITE_APP_TITLE
const auth = useAuth()
const route = useRoute()
const { session, signOut } = auth
init()
</script>
